// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2SMHF","activeHandle":"RangeSlider_activeHandle__2Ja6j"};